import { useLocation, Navigate, Outlet } from "react-router-dom"
import dataApplicationsContext from "../../context/dataApplicationsContext";
import { useContext, useEffect } from "react";
import ErrorUnauthorize from "../../components/ErrorUnauthorize";

const RequireAuth = () => {
  const { auth } = useContext(dataApplicationsContext);
  
  return (
    auth?.user?.email 
      ? <Outlet /> 
      : <ErrorUnauthorize />
  )
}

export default RequireAuth
